// extracted by mini-css-extract-plugin
module.exports = {"box":"CountryCard_box__2pv4k","card":"CountryCard_card__31O4Y","flag":"CountryCard_flag__1xUHa","btn":"CountryCard_btn__14uZu","countryTextBox":"CountryCard_countryTextBox__3X2qw"};